var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3821 15.2328V15.2298C11.4215 15.2316 11.4611 15.2328 11.5009 15.2328C12.8789 15.2328 14 14.1117 14 12.7337V0.709434C14 0.459768 13.8726 0.233326 13.6592 0.103709C13.4457 -0.0259074 13.1861 -0.0345077 12.9645 0.0806784L11.6563 0.760811L10.5877 0.194995C10.1492 -0.0372134 9.6256 -0.0372134 9.18709 0.194995L8.121 0.759522L7.05492 0.194995C6.61634 -0.0372134 6.09275 -0.0372134 5.6543 0.194995L4.5857 0.760811L3.27746 0.0806462C3.05591 -0.0345399 2.79629 -0.0258752 2.58283 0.103677C2.36943 0.233261 2.24201 0.459704 2.24201 0.709402V10.141H0.579796C0.259587 10.141 0 10.4006 0 10.7208V12.7337C0 14.0832 1.07539 15.1856 2.41414 15.2306V15.2328H11.3821ZM3.40156 1.45212L4.26082 1.89888C4.46745 2.00624 4.71364 2.00534 4.91921 1.89634L6.19692 1.21978C6.29565 1.16747 6.41357 1.16751 6.51223 1.21978L7.78949 1.89615C7.99702 2.00595 8.24489 2.00602 8.45261 1.89608L9.72971 1.21982C9.8284 1.16754 9.9463 1.16751 10.0451 1.21982L11.3226 1.89628C11.5283 2.00528 11.7745 2.00628 11.9812 1.89882L12.8404 1.45212V12.7337C12.8404 13.4723 12.2395 14.0732 11.5009 14.0732C10.7623 14.0732 10.1614 13.4723 10.1614 12.7337V10.7208C10.1614 10.4006 9.90184 10.141 9.58164 10.141H3.40156V1.45212ZM1.15959 12.7337V11.3006H9.00191V12.7337C9.00191 13.2263 9.14576 13.6857 9.39282 14.0732H2.49908C1.76048 14.0732 1.15959 13.4723 1.15959 12.7337Z",
    fill: "#43A022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4695 8.47286C11.4695 8.15265 11.2099 7.89307 10.8897 7.89307H5.04757C4.72736 7.89307 4.46777 8.15265 4.46777 8.47286C4.46777 8.79307 4.72736 9.05266 5.04757 9.05266H10.8897C11.2099 9.05266 11.4695 8.79307 11.4695 8.47286Z",
    fill: "#43A022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.04757 6.79802H10.8897C11.2099 6.79802 11.4695 6.53843 11.4695 6.21822C11.4695 5.89802 11.2099 5.63843 10.8897 5.63843H5.04757C4.72736 5.63843 4.46777 5.89802 4.46777 6.21822C4.46777 6.53843 4.72733 6.79802 5.04757 6.79802Z",
    fill: "#43A022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.04757 4.70427H8.31282C8.63302 4.70427 8.89261 4.44468 8.89261 4.12447C8.89261 3.80427 8.63302 3.54468 8.31282 3.54468H5.04757C4.72736 3.54468 4.46777 3.80427 4.46777 4.12447C4.46777 4.44468 4.72733 4.70427 5.04757 4.70427Z",
    fill: "#43A022"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.a7c841c484cf06e425102607bb1ef824.svg";
export { ForwardRef as ReactComponent };